import _sfc_main from "./MessageListPC.vue2.mjs";
/* empty css                    */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: _setup.isMobile ? "message-list-container-h5" : "message-list-container" }, [_c("div", { ref: "messageListRef", staticClass: "message-list", attrs: { "id": "messageScrollList" } }, _vm._l(_setup.messageList, function(item, index) {
    return _c("div", { key: item.ID, ref: "messageAimId", refInFor: true, class: ["message-item", `${"out" === item.flow ? "is-me" : ""}`] }, [_setup.getDisplaySenderName(index) ? _c("div", { staticClass: "message-header", attrs: { "title": item.nick || item.from } }, [_vm._v(" " + _vm._s(_setup.getDisplayName(item.from)) + " ")]) : _vm._e(), _c("div", { staticClass: "message-body" }, [_c(_setup.MessageText, { attrs: { "data": item.payload.text } })], 1)]);
  }), 0)]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "71a45eaf"
);
const messageListPC = __component__.exports;
export {
  messageListPC as default
};
